module.exports = __webpack_public_path__ + "static/media/ico-declined.3ead7b59.svg";